import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// Unused imports removed
import Pagination from "../../common/TablePagination";
import {
  deleteFranchise,
  getFranchises,
  getLocationById,
  addFranchise,
} from "../../../services/franchiseService";
import CancelPopup from "../../common/CancelPopup";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import Loader from "../../common/Loader";
import TradingHoursPopup from "../../Admin/FundraiserList/TradingHoursPopup";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../../common/SearchBar";
import { Dropdown, Drawer, Breadcrumb } from "antd";
import FilterPanel from "../../common/FilterPanel";
import AddNewLocation from "../../common/OfferForm/Location/AddNewLocation";
import UploadCSVDrawer from "../../common/OfferForm/Location/UploadCSVDrawer";
import { ReactComponent as LocationIcon } from "../../../Assets/Icons/Location.svg";
import { ReactComponent as CSVIcon } from "../../../Assets/Icons/csvupload.svg";
import { ReactComponent as BackArrow } from "../../../Assets/Icons/backWhiteIcon.svg";
import "../../common/OfferForm/offerform.scss";
import toast from "../../../utils/toast";
// Unused import removed
import DetailsModal from "../../common/DetailsModal";
import PopupContent from "./PopupContent";

const StoreListTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.franchiseReducer?.loading);
  const selectedMerchant = useSelector(
    (state) => state?.merchantReducer.selectedMerchent
  );
  const [isTradeOpen, setIsTradeOpen] = useState();
  const [tradeHours] = useState();
  const [statusToggled] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [storeDetails, setStoreDetails] = useState(null);
  const [addClicked, setAddClicked] = useState(false);
  const [csvDrawerOpen, setCsvDrawerOpen] = useState(false);

  const items = [
    {
      title: "Other Stores",
    },
    {
      title: "Stores List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Merchant Name",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Store Location Address",
    },
    {
      name: "Actions",
    },
  ];

  const [deleteClicked, setDeleteClicked] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [allStores, setAllStores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterParams, setFilterParams] = useState({
    duration: null,
  });
  // Debounced search value to avoid rapid API calls
  const [debouncedQuery, setDebouncedQuery] = useState("");

  // Client-side filter to extend search to phone and address too
  const visibleStores = useMemo(() => {
    if (!Array.isArray(allStores) || (searchQuery || "").trim() === "") {
      return allStores;
    }
    const needle = (searchQuery || "").toLowerCase();
    return allStores.filter((f) => {
      const business = f?.merchant?.businessName || "";
      const email = f?.email || "";
      const phone = f?.phone || "";
      const address = f?.googlePlaceId?.address || "";
      return (
        business.toLowerCase().includes(needle) ||
        email.toLowerCase().includes(needle) ||
        String(phone).toLowerCase().includes(needle) ||
        address.toLowerCase().includes(needle)
      );
    });
  }, [allStores, searchQuery]);

  const getAllStores = async (search) => {
    const isClientSearch = Boolean((search || "").trim());

    // Build params object
    const params = {
      page: 1, // Always fetch page 1 since we'll do client-side pagination
      limit: 1000, // Fetch all stores for client-side filtering
      search: isClientSearch ? null : (search || null),
    };

    // Only add duration if it's actually set (not null/undefined)
    if (filterParams.duration) {
      // Convert "Today" -> "today", "This Week" -> "this_week", etc.
      params.duration = filterParams.duration.toLowerCase().replace(/\s+/g, "_");
    }

    // Remove null/undefined values from params
    Object.keys(params).forEach(key => {
      if (params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    console.log("Fetching stores with params:", params);

    const storePromise = await dispatch(getFranchises(params)).unwrap();
    if (storePromise?.success === true) {
      let stores = storePromise?.data || [];

      // Client-side filtering by date if duration is set
      if (filterParams.duration) {
        const now = new Date();
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay()); // Start of week (Sunday)
        startOfWeek.setHours(0, 0, 0, 0);
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
        const startOfYear = new Date(now.getFullYear(), 0, 1, 0, 0, 0);

        stores = stores.filter(store => {
          if (!store.createdAt) return false;
          const createdDate = new Date(store.createdAt);

          switch (filterParams.duration) {
            case 'Today':
              return createdDate >= startOfToday;
            case 'This Week':
              return createdDate >= startOfWeek;
            case 'This Month':
              return createdDate >= startOfMonth;
            case 'This Year':
              return createdDate >= startOfYear;
            default:
              return true;
          }
        });

        console.log(`Filtered stores for ${filterParams.duration}:`, stores.length, "stores");
      }

      // Client-side pagination
      const itemsPerPage = 10;
      const totalPagesCalc = Math.ceil(stores.length / itemsPerPage) || 1;
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedStores = stores.slice(startIndex, endIndex);

      setAllStores(paginatedStores);
      setTotalPages(totalPagesCalc);

      // Keep current page if valid, otherwise reset to 1
      if (currentPage > totalPagesCalc) {
        setCurrentPage(1);
      }
    }
  };

  // Debounce searchQuery into debouncedQuery
  useEffect(() => {
    const handle = setTimeout(() => setDebouncedQuery(searchQuery), 400);
    return () => clearTimeout(handle);
  }, [searchQuery]);

  // Single fetch effect: runs when page, merchant, filters, or debouncedQuery change
  useEffect(() => {
    getAllStores(debouncedQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusToggled, deleteSuccess, currentPage, selectedMerchant, filterParams, debouncedQuery]);

  const fetchStoreDetailsData = async (storeId) => {
    try {
      const storeDetailsPromise = await dispatch(
        getLocationById({ id: storeId, silent: true })
      )?.unwrap();
      if (storeDetailsPromise?.success === true) {
        setStoreDetails(storeDetailsPromise?.data);
      }
    } catch (error) {
      console.error("Error fetching offer details:", error);
    }
  };

  const openPopup = (storeId) => {
    setStoreDetails(null);
    setIsDetailOpen(true);
    fetchStoreDetailsData(storeId);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const [filterData] = useState([
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year"],
      defaultValue: null,
      multiSelect: false,
    },
  ]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value (null means no filter)
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  // Update the handleReset function
  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);

    // Reset filter params to trigger new API call
    setFilterParams({
      duration: null,
    });
  };

  const handleApply = () => {
    console.log("Applying filters:", selections);

    // Reset to page 1 when applying new filter
    setCurrentPage(1);

    // Update filter params to trigger new API call
    setFilterParams({
      duration: selections.duration,
    });

    setOpen(false);
  };

  // Toggle handler currently unused in this view

  // Hours click handler managed via popup open

  const handleCloseTradeHours = () => {
    setIsTradeOpen(false);
  };

  const handleEditClick = (id) => {
    navigate("/merchant/franchise-form", {
      state: {
        id: id,
      },
    });
  };

  const handleDeleteClick = (idOrObj) => {
    setDeleteClicked(true);
    const id = typeof idOrObj === 'object' && idOrObj !== null ? idOrObj._id : idOrObj;
    setSelectedStoreId(id);
  };

  const handleKeepStore = () => {
    setDeleteClicked(false);
  };

  const handleDeleteStore = async () => {
    // Safety check: ensure selectedStoreId is a valid string ID
    let safeId = selectedStoreId;
    if (typeof safeId === 'object' && safeId !== null) {
      safeId = safeId._id || safeId.id;
    }

    if (safeId && typeof safeId === 'string') {
      const deletePromise = await dispatch(
        deleteFranchise({ id: safeId })
      )?.unwrap();
      if (deletePromise?.success === true) {
        setDeleteClicked(false);
        setDeleteSuccess(!deleteSuccess);
        // Close detail popup if it was open for this store
        if (isDetailOpen) {
          closePopup();
        }
        toast.success("Store deleted successfully");
      }
    } else {
      console.error("Attempted to delete with invalid ID:", selectedStoreId);
      toast.error("Error: Invalid store ID.");
    }
  };

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    // Reset to first page for a new search term
    setCurrentPage(1);
  };

  const closePopup = () => {
    setStoreDetails(null);
    setIsDetailOpen(false);
  };

  const handleAcceptedFiles = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const isCSV = file.name.toLowerCase().endsWith(".csv");
    if (!isCSV) {
      toast.error("Only .csv files are allowed!");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split(/\r?\n/).filter((line) => line.trim() !== "");
      if (lines.length < 2) {
        toast.error("CSV must have headers and at least one row.");
        return;
      }

      const splitCsvLine = (line) => {
        const matches = line.trim().match(/("[^"]*"|[^,]+)(?=,|$)/g);
        if (!matches) return [];
        return matches.map((m) => m.replace(/^"|"$/g, "").trim());
      };

      const headers = (splitCsvLine(lines[0]) || [])
        .map((h) => h.trim().toLowerCase().replace(/\r/g, ""));

      const days = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];

      const rawRows = lines.slice(1).map((line, index) => {
        const values = splitCsvLine(line).map((v) => v.trim().replace(/\r/g, ""));
        const row = {};
        headers.forEach((key, i) => {
          row[key] = values[i] || "";
        });

        const tradingHours = days.map((day) => ({
          day,
          openTime: row[`${day}_open`] ?? "",
          closeTime: row[`${day}_close`] ?? "",
        }));

        const phoneDigits = String(row["phone"] || "").replace(/\D/g, "");

        return {
          name: row["name"] || "",
          email: row["email"] || "",
          phone: phoneDigits,
          address: row["address"] || "",
          tradingHours,
          googlePlaceId: row["googleplaceid"] || null,
          _id: `temp_${Date.now()}_${index}`,
        };
      });

      const data = rawRows
        .filter((r) => r.name && (r.address || r.googlePlaceId))
        .filter((r, idx, arr) => {
          if (!r.phone) return true;
          return arr.findIndex(x => x.phone === r.phone) === idx;
        });

      if (data.length > 0) {
        (async () => {
          const resultAction = await dispatch(addFranchise({ locations: data }));
          const payload = resultAction?.payload;
          if (payload?.success === true) {
            toast.success(`${data.length} location(s) parsed successfully`);
            setCsvDrawerOpen(false);
            getAllStores();
          }
        })();
      }
    };
    reader.readAsText(file);
  };


  console.log('storeDetails', storeDetails)
  return (
    <>
      {loading === true && <Loader />}
      {isDetailOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from { transform: translateY(-20px) scale(0.95); opacity: 0; }
                to { transform: translateY(0) scale(1); opacity: 1; }
              }
            `}
          </style>
          <div style={{
            animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <DetailsModal
              handleClose={closePopup}
              content={
                <PopupContent
                  storeDetails={storeDetails}
                  handleDeleteClick={handleDeleteClick}
                  handleEditClick={handleEditClick}
                  onAddLocation={() => {
                    setIsDetailOpen(false);
                    setAddClicked(true);
                  }}
                  onUploadCSV={() => {
                    setIsDetailOpen(false);
                    setCsvDrawerOpen(true);
                  }}
                />
              }
              popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
            />
          </div>
        </div>
      )}
      {tradeHours !== null && isTradeOpen === true && (
        <TradingHoursPopup
          tradeHours={tradeHours}
          handleCloseTradeHours={handleCloseTradeHours}
        />
      )}
      <div className="px-4 md:px-0">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center col-span-12 gap-4 md:gap-0">
          <div className="flex flex-col items-start w-full md:w-auto">
            <p className="text-[20px] md:text-[24px] font-[600] text-[#303030] font-poppins mb-1">
              Stores List
            </p>
            <Breadcrumb separatorMargin="" items={items} separator=">" />
          </div>
          <div className="w-full md:w-auto flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-3 sm:gap-4">
            <button
              className="flex relative h-[38px] rounded-[5px] bg-[#00ADEF] text-[13px] sm:text-[14px] font-[600] font-nunito text-[#FFFFFF] items-center justify-center pl-[2.5rem] pr-[1rem] whitespace-nowrap overflow-hidden w-full sm:w-auto"
              onClick={() => setAddClicked(true)}
              style={{ minWidth: "auto" }}
            >
              <LocationIcon
                className="absolute left-[0.75rem] top-1/2 transform -translate-y-1/2 w-4 h-5"
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <span>Add A New Store Location</span>
            </button>
            <button
              className="flex relative h-[38px] rounded-[5px] bg-[#00ADEF] text-[13px] sm:text-[14px] font-[600] font-nunito text-[#FFFFFF] items-center justify-center pl-[2.5rem] pr-[1rem] whitespace-nowrap overflow-hidden w-full sm:w-auto"
              onClick={() => setCsvDrawerOpen(true)}
              style={{ minWidth: "auto" }}
            >
              <CSVIcon
                className="absolute left-[0.75rem] top-1/2 transform -translate-y-1/2 w-5 h-5"
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <span>Upload Via CSV</span>
            </button>
          </div>
        </div>
        <div className="w-full flex flex-row justify-between items-center mt-4 gap-2">
          <SearchBar
            parentDivClass="flex-1 md:flex-none md:w-[40%] lg:w-[35%] xl:w-[30%]"
            divClassName="relative w-full"
            inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
            iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[18px] h-[18px]"
            placeholder="Search..."
            value={searchQuery}
            handleChange={(e) => handleSearchChange(e.target.value)}
          />
          <Dropdown
            overlay={
              <FilterPanel
                filterData={filterData}
                selections={selections}
                handleApply={handleApply}
                handleCancel={handleCancel}
                handleReset={handleReset}
                handleSelectionChange={handleSelectionChange}
              />
            }
            trigger={["click"]}
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottomRight"
            overlayStyle={{
              minWidth: "320px",
              maxHeight: "80vh",
              zIndex: 1000,
            }}
            overlayClassName="filter-dropdown-overlay"
          >
            <button className="flex justify-center items-center gap-2 border border-[#00ADEF] rounded-md p-3 text-lg font-medium outline-none h-[45px] w-[50px] md:h-[40px] md:w-auto px-0 md:px-3 bg-white">
              <div className="flex items-center gap-2">
                <FiltersIcon className="w-[20px] h-[20px]" />
                <span className="hidden md:block font-[500] text-[14px] font-poppins leading-[22px] text-[#00ADEF]">
                  Filters
                </span>
              </div>
              <DownArrow className="hidden md:block" />
            </button>
          </Dropdown>
        </div>
      </div>
      {deleteClicked === true ? (
        <CancelPopup
          handleNo={handleKeepStore}
          handleYes={handleDeleteStore}
          heading={"Delete Store"}
          content={"Are you sure you want to delete this store?"}
          image={deleteImg}
        />
      ) : null}
      <div className="col-span-12 mt-8">
        {/* Mobile View - Cards */}
        <div className="block md:hidden space-y-4 mb-4 px-4">
          {visibleStores?.map((franchise, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-[10px] shadow-[0px_0px_10px_rgba(0,0,0,0.05)] border border-[#EBEBEB]"
            >
              <div className="mb-1">
                <h3 className="font-poppins font-[700] text-[13px] sm:text-[14px] text-[#303030]">
                  {franchise?.merchant?.businessName}
                </h3>
                <p className="font-poppins font-[400] text-[11px] sm:text-[12px] text-[#8C8C8C]">
                  {franchise?.email}
                </p>
              </div>

              <div className="flex justify-start items-center gap-2 mb-2">
                <span className="font-poppins font-[500] text-[12px] sm:text-[13px] text-[#8C8C8C]">
                  Contact:
                </span>
                <span className="font-poppins font-[500] text-[12px] sm:text-[13px] text-[#303030]">
                  {franchise?.phone}
                </span>
              </div>

              <div className="mb-4">
                <p className="font-poppins font-[500] text-[12px] sm:text-[13px] text-[#8C8C8C] mb-1">
                  Address:
                </p>
                <p className="font-poppins font-[500] text-[12px] sm:text-[13px] text-[#303030] leading-tight">
                  {franchise?.googlePlaceId?.address}
                </p>
              </div>

              <button
                className="w-full flex justify-center items-center border border-[#00ADEF] bg-[#E0F7FF] rounded-[5px] h-[40px]"
                onClick={() => openPopup(franchise?._id)}
              >
                <span className="font-[600] text-[13px] sm:text-[14px] text-[#00ADEF] font-poppins">
                  View Details
                </span>
              </button>
            </div>
          ))}
        </div>

        {/* Desktop View - Table */}
        <TableContainer
          className="hidden md:block"
          style={{ width: "100%", overflowX: "auto" }}
        >
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns.map((column) => {
                  return (
                    <TableCell className="!text-[#FFFFFF]">
                      {column.name}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {visibleStores?.map((franchise, index) => {
                return (
                  <TableRow
                    className="h-[50px]"
                    sx={{
                      boxShadow: "0px 4px 4px 0px #00000040",
                      backgroundColor:
                        (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                    }}
                  >
                    <TableCell className="max-w-[50px]">
                      {(currentPage - 1) * 10 + index + 1}
                    </TableCell>
                    <TableCell
                      title={franchise?.merchant?.businessName}
                      className="max-w-[80px] truncate"
                    >
                      {franchise?.merchant?.businessName}
                    </TableCell>
                    <TableCell
                      title={franchise?.email}
                      className="max-w-[150px] truncate"
                    >
                      {franchise?.email}
                    </TableCell>
                    <TableCell
                      title={franchise?.phone}
                      className="max-w-[100px]"
                    >
                      {franchise?.phone}
                    </TableCell>
                    <TableCell
                      title={franchise?.googlePlaceId?.address}
                      className="max-w-[200px] truncate"
                    >
                      {franchise?.googlePlaceId?.address}
                    </TableCell>
                    <TableCell className="max-w-[120px]">
                      <button
                        className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                        onClick={() => openPopup(franchise?._id)}
                      >
                        <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                          View Details
                        </span>
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>

      {/* Add Location Drawer */}
      <Drawer
        placement="right"
        onClose={() => setAddClicked(false)}
        open={addClicked}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer add-location-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: 'none' }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div className="close-icon-wrapper" onClick={() => setAddClicked(false)}>
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">Add New Store Location</h2>
            <p className="drawer-subtitle">
              Enter Store location info to help customers find you easily.
            </p>
          </div>
        </div>

        <AddNewLocation
          allStores={false}
          setLocations={setAllStores}
          setSelectedLocations={() => { }}
          setSelectedLocationIds={() => { }}
          setLocationNames={() => { }}
          selectedMerchant={selectedMerchant}
          onSuccess={() => {
            setAddClicked(false);
            getAllStores();
          }}
          isDrawer={true}
        />
      </Drawer>

      {/* Upload CSV Drawer */}
      <Drawer
        placement="right"
        onClose={() => setCsvDrawerOpen(false)}
        open={csvDrawerOpen}
        width={window.innerWidth < 640 ? "100%" : 520}
        className="add-store-drawer csv-upload-sidebar"
        rootClassName="modern-drawer-root"
        headerStyle={{ display: 'none' }}
        closeIcon={null}
      >
        <div className="drawer-custom-header">
          <div className="close-icon-wrapper" onClick={() => setCsvDrawerOpen(false)}>
            <BackArrow className="w-5 h-5" />
          </div>
          <div className="drawer-header-content">
            <h2 className="drawer-title">Upload Locations via CSV</h2>
            <p className="drawer-subtitle">
              Quickly add multiple store locations by uploading a CSV file.
            </p>
          </div>
        </div>
        <UploadCSVDrawer
          onClose={() => setCsvDrawerOpen(false)}
          onUploadSuccess={handleAcceptedFiles}
          sampleFileUrl="/sample-locations.csv"
        />
      </Drawer>
    </>
  );
};

export default StoreListTable;
